import { ClipLoader } from "react-spinners";
import { LoadingStatus, selectRoles } from "../../../common/commonSlice";
import { PredeterminedRoles, RoleProfile } from "../../configurationAPI";
import { ReactComponent as ArrowUp } from "../../../../Assets/common/images/upMenu.svg";
import { ReactComponent as ArrowDown } from "../../../../Assets/common/images/downMenu.svg";
import { Checkbox } from "@material-ui/core";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import {
  addRolesToCurrent,
  removeRolesFromCurrent,
} from "../../configurationSlice";

export interface RolesComponentProps {
  width?: string;
  predeterminedRoles: PredeterminedRoles[];
  currentRoles: string[];
  immutableRoles: string[];
  loading: LoadingStatus;
  changeRolesFunction?: Function;
  visibility: "hidden" | "visible";
  darkMode?: boolean;
  dontShowButtons?: boolean;
  ownRoles?: boolean;
  disabled?: boolean;
  roleProfile?: RoleProfile;
}

export const RolesComponent = (props: RolesComponentProps) => {
  let dispatch = useAppDispatch();
  const userRoles = useAppSelector(selectRoles);
  const [openList, setOpenList] = useState<boolean[]>([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const [personalizedOpen, setPersonalizedOpen] = useState(false);
  const [inputPersonalized, setInputPersonalized] = useState<string>("");

  const getDescription = () => {
    if (props.roleProfile) {
      if (props.ownRoles) {
        return (
          <p
            style={{
              fontSize: "13px",
              color: "white",
              textAlign: "start",
              margin: "0",
            }}
          >
            Tienes asignado el <em>rol</em>{" "}
            <strong> {props.roleProfile.name}</strong> que contiene los
            siguientes permisos. Puedes expandir cada uno de las secciones para
            ver los permisos especificos.
          </p>
        );
      } else {
        return (
          <p
            style={{
              fontSize: "13px",
              color: "white",
              textAlign: "start",
              margin: "0",
            }}
          >
            Este usuario tiene asignado el <em> rol</em>{" "}
            <strong> {props.roleProfile.name}</strong> que contiene los
            siguientes permisos. Puedes expandir cada uno de las secciones para
            ver los permisos especificos.
          </p>
        );
      }
    }
    return (
      <p
        style={{
          fontSize: "13px",
          color: "white",
          textAlign: "start",
          margin: "0",
        }}
      >
        {props.ownRoles
          ? "A continuación puedes ver los permisos que tienes asignado actualmente. Puedes expandir cada uno de las secciones para ver los permisos especificos."
          : "A continuación puedes ver los permisos que este usuario tiene asignado actualmente. Puedes expandir cada uno de las secciones para ver los permisos especificos."}
      </p>
    );
  };

  const getPersonalizedRoles = () => {
    let personalizedRolesTemp = props.currentRoles;
    props.predeterminedRoles.forEach((prede) => {
      personalizedRolesTemp = personalizedRolesTemp.filter((rolex) => {
        return rolex !== prede.adminRole.role;
      });

      prede.containedRoles.forEach((roleInfoPrede) => {
        personalizedRolesTemp = personalizedRolesTemp.filter((rolex) => {
          return rolex !== roleInfoPrede.role;
        });
      });
    });
    personalizedRolesTemp = personalizedRolesTemp.filter((rolex) => {
      return (
        rolex !== "Client" &&
        rolex !== "User" &&
        rolex !== "Admin" &&
        rolex !== "SuperAdmin"
      );
    });

    return personalizedRolesTemp;
  };

  const changeOpenList = (indicator: number) => {
    let tempList = openList;
    let personalizedShouldClose = false;
    for (let i = 0; i < openList.length; i++) {
      if (i == indicator) {
        personalizedShouldClose = true;
        tempList[i] = !tempList[i];
      } else {
        tempList[i] = false;
      }
    }
    setOpenList([...tempList]);
    if (indicator < 0) {
      setPersonalizedOpen(true);
    } else {
      setPersonalizedOpen(!personalizedShouldClose);
    }
  };

  const changePersonalized = (role: string, action: "add" | "remove") => {
    let isPredetermined = false;
    props.predeterminedRoles.every((v) => {
      if (v.adminRole.role === role) {
        isPredetermined = true;
        return false;
      }
      v.containedRoles.every((c) => {
        if (c.role === role) {
          isPredetermined = true;
          return false;
        }
      });
    });

    if (props.currentRoles.includes(role)) {
      isPredetermined = true;
    }

    switch (action) {
      case "add":
        if (!isPredetermined) {
          dispatch(addRolesToCurrent([role]));
        }
        setInputPersonalized("");

        break;
      case "remove":
        dispatch(removeRolesFromCurrent([role]));
        break;
      default:
        break;
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "center",
        width: props.width,
        visibility: props.visibility,
      }}
    >
      <div
        style={{
          width: "100%",
          padding: "8px 0px 8px 0px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          fontSize: "15px",
          backgroundColor: props.darkMode ? "#1A617D" : "rgba(0,0,0,0.4)",
          color: props.darkMode ? "white" : "rgba(255,255,255, 0.8)",
          borderRadius: "8px 8px 0px 0px",
          fontWeight: "600",
        }}
      >
        Permisos
      </div>
      <div
        style={{
          width: "100%",
          padding: "12px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "start",
          fontSize: "13px",
          backgroundColor: props.darkMode
            ? "rgb(29, 72, 89)"
            : "rgba(0,0,0,0.2)",
          minHeight: "280px",
          borderRadius: "0px 0px 8px 8px",
          overflow: "auto",
        }}
      >
        {!props.dontShowButtons && (
          <div
            style={{
              marginBottom: "10px",
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "end",
            }}
          >
            <div
              style={{
                width: "73%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "start",
                alignItems: "start",
              }}
            >
              {getDescription()}
            </div>
            <button
              onClick={(e) => {
                e.preventDefault();
                if (props.changeRolesFunction) {
                  props.changeRolesFunction();
                }
              }}
              style={{
                padding: "8px 10px 8px 10px",
                textAlign: "center",
                color: "#FFF",
                background: "rgba(0,0,0,0.3)",
                borderRadius: "8px",
                height: "fit-content",
                border: "none",
                width: "25%",
                fontWeight: "600",
              }}
            >
              Cambiar permisos o roles
            </button>
          </div>
        )}
        {props.loading === "pending" || openList.length === 0 ? (
          <ClipLoader color="#FFF" size="120px" />
        ) : (
          <div style={{ borderRadius: "8px", overflow: "auto", width: "100%" }}>
            {props.predeterminedRoles.map((roleData, i) => {
              if (
                (props.ownRoles || !userRoles.includes("SuperAdmin")) &&
                !props.immutableRoles.includes("users.edit") &&
                !props.immutableRoles.includes("users.admin") &&
                roleData.adminRole.role === "users.admin"
              ) {
                return <div key={i}></div>;
              } else {
                return (
                  <div key={i} style={{ width: "100%", marginBottom: "2px" }}>
                    <RoleItem
                      disabled={props.disabled}
                      predeterminedRoles={roleData}
                      currentRoles={props.currentRoles}
                      expanded={openList[i]}
                      expandFunction={() => {
                        changeOpenList(i);
                      }}
                    />
                  </div>
                );
              }
            })}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "start",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    padding: "12px 12px 12px 12px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    background: "rgba(0,0,0,0.1)",
                    width: "100%",
                  }}
                >
                  <h4
                    style={{
                      fontSize: "14px",
                      fontWeight: "700",
                      color: "#FFF",
                      margin: "0",
                    }}
                  >
                    Permisos personalizados
                  </h4>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "end",
                      alignItems: "center",
                    }}
                  >
                    {personalizedOpen ? (
                      <ArrowUp
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.preventDefault();
                          setPersonalizedOpen(false);
                        }}
                      />
                    ) : (
                      <ArrowDown
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.preventDefault();
                          changeOpenList(-1);
                        }}
                      />
                    )}
                  </div>
                </div>
                {personalizedOpen && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      padding: "2% 2% 1% 2%",
                      background: "rgba(0,0,0,0.2)",
                    }}
                  >
                    {!props.disabled && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "28%",
                        }}
                      >
                        <form>
                          <input
                            value={inputPersonalized}
                            onChange={(e) => {
                              setInputPersonalized(e.target.value);
                            }}
                            type="text"
                            placeholder="Ej: SARLAFT"
                            style={{
                              border: "0.5px solid rgba(255,255,255,0.2)",
                              borderRadius: "6px",
                              background: "rgba(255,255,255,0.05)",
                              padding: "5px 0px 5px 0px",
                              fontSize: "12px",
                              fontWeight: "600",
                              textAlign: "center",
                              color: "#FFF",
                              width: "100%",
                              marginBottom: "10px",
                            }}
                          />
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              if (inputPersonalized.length > 0) {
                                changePersonalized(inputPersonalized, "add");
                              }
                            }}
                            style={{
                              width: "100%",
                              border: "none",
                              borderRadius: "8px",
                              background: "rgba(0,0,0,0.2)",
                              color: "white",
                              padding: "4px 4px",
                              marginBottom: "10px",
                            }}
                          >
                            Agregar permiso
                          </button>
                        </form>
                      </div>
                    )}
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "auto auto auto",
                        width: "75%",
                      }}
                    >
                      {getPersonalizedRoles().map((role, rl) => {
                        return (
                          <div
                            key={rl}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              margin: "0px 4px 5px 8px",
                              border: "none",
                              borderRadius: "6px",
                              background: "rgba(0,0,0,0.2)",
                              maxHeight: "25px",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                padding: "2px 5px 2px 8px",
                                fontSize: "11px",
                                fontWeight: "700",
                                textAlign: "center",
                                color: "#FFF",
                              }}
                            >
                              {role}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                height: "100%",
                              }}
                            >
                              <div
                                style={{
                                  margin: "1px 0 0 0",
                                  borderLeft: "1px solid rgba(255,255,255,0.7)",
                                  height: "22px",
                                }}
                              ></div>
                              <div
                                onClick={(e) => {
                                  e.preventDefault();
                                  changePersonalized(role, "remove");
                                }}
                                style={{
                                  padding: "0 8px 0 8px",
                                  fontSize: "14px",
                                  fontWeight: "800",
                                  textAlign: "center",
                                  color: "#FFF",
                                  background: "rgba(0,0,0,0.4)",
                                  borderRadius: "0 6px 6px 0",
                                  cursor: "pointer",
                                  height: "100%",
                                }}
                              >
                                X
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export const RoleItem = (props: {
  predeterminedRoles: PredeterminedRoles;
  currentRoles: string[];
  expanded: boolean;
  expandFunction: Function;
  disabled?: boolean;
}) => {
  const dispatch = useAppDispatch();
  const isIndeterminate = () => {
    let counter = 0;
    props.predeterminedRoles.containedRoles.forEach((role) => {
      if (props.currentRoles.includes(role.role)) {
        counter++;
      }
    });
    return (
      counter !== 0 &&
      counter !== props.predeterminedRoles.containedRoles.length
    );
  };

  const checked = (role: string) => {
    return props.currentRoles.includes(role);
  };

  const checkedMain = () => {
    let counter = 0;
    props.predeterminedRoles.containedRoles.forEach((role) => {
      if (props.currentRoles.includes(role.role)) {
        counter++;
      }
    });
    return counter === props.predeterminedRoles.containedRoles.length;
  };

  const almostCheckedMain = () => {
    let counter = 0;
    props.predeterminedRoles.containedRoles.forEach((role) => {
      if (props.currentRoles.includes(role.role)) {
        counter++;
      }
    });
    return counter === props.predeterminedRoles.containedRoles.length - 1;
  };

  const mainChangeRole = () => {
    let tempList: string[] = [];
    props.predeterminedRoles.containedRoles.forEach((role) => {
      tempList.push(role.role);
    });
    tempList.push(props.predeterminedRoles.adminRole.role);
    if (!checkedMain() || isIndeterminate()) {
      dispatch(addRolesToCurrent(tempList));
    } else {
      dispatch(removeRolesFromCurrent(tempList));
    }
  };

  const changeRole = (role: string) => {
    let tempList: string[] = [role];

    if (!checked(role)) {
      if (almostCheckedMain()) {
        tempList.push(props.predeterminedRoles.adminRole.role);
      }
      dispatch(addRolesToCurrent(tempList));
    } else {
      tempList.push(props.predeterminedRoles.adminRole.role);
      dispatch(removeRolesFromCurrent(tempList));
    }
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "center",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <div
          style={{
            padding: "2px 12px 2px 12px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            background: "rgba(0,0,0,0.1)",
            width: "100%",
          }}
        >
          <h4
            style={{
              fontSize: "14px",
              fontWeight: "700",
              color: "#FFF",
              margin: "0",
            }}
          >
            {props.predeterminedRoles.adminRole.roleLabel}
          </h4>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <Checkbox
              disabled={props.disabled}
              style={{ color: "#FFF" }}
              indeterminate={isIndeterminate()}
              checked={checkedMain()}
              onChange={() => {
                mainChangeRole();
              }}
            />
            {props.expanded ? (
              <ArrowUp
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault();
                  props.expandFunction();
                }}
              />
            ) : (
              <ArrowDown
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault();
                  props.expandFunction();
                }}
              />
            )}
          </div>
        </div>
        {props.expanded && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "2% 5% 1% 5%",
              background: "rgba(0,0,0,0.2)",
            }}
          >
            {props.predeterminedRoles.containedRoles.map((roleDetail, e) => {
              return (
                <div
                  key={e}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    padding: "0px 8px 0px 8px",
                    background: "rgba(0,0,0,0.1)",
                    justifyContent: "space-between",
                    alignItems: "center",
                    margin: "0 0 8px 0",
                  }}
                >
                  <h5
                    style={{
                      margin: "0",
                      fontSize: "14px",
                      fontWeight: "700",
                      color: "#FFF",
                    }}
                  >
                    {roleDetail.roleLabel}
                  </h5>
                  <Checkbox
                    disabled={props.disabled}
                    style={{ color: "#FFF" }}
                    checked={checked(roleDetail.role)}
                    onChange={() => {
                      changeRole(roleDetail.role);
                    }}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
